<ng-container>
  <div>
    <img alt="" src="./assets/images/imdb_star.png" class="icon">
    {{getString('imdb')}}: {{getValueForDisplay(currentValues.imdb)}}
  </div>
  <mat-slider min="0" max="10" step="0.5" [value]="currentValues.imdb" class="slider" (input)="imdbChange($event)"></mat-slider>
</ng-container>

<div>
  <img alt="" src="./assets/images/rotten_fresh.png" class="icon">
  {{getString('rottenTomatoes')}}: {{getValueForDisplay(currentValues.rotten)}}
</div>
<mat-slider min="0" max="100" step="0.5" [value]="currentValues.rotten" class="slider" (input)="rottenChange($event)"></mat-slider>

<ng-container *ngIf="getCurrentStore() === 'itunes'">
  <div>
    <img alt="" src="./assets/images/letterboxd.png" class="icon">
    {{getString('letterboxdRating')}}: {{getValueForDisplay(currentValues.letterboxd)}}
  </div>
  <mat-slider min="0" max="5" step="0.1" [value]="currentValues.letterboxd" class="slider" (input)="letterboxdChange($event)"></mat-slider>
</ng-container>

<ng-container>
  <div>
    <img alt="" src="./assets/images/metacritic.png" class="icon">
    {{getString('metacritic')}}: {{getValueForDisplay(currentValues.metacritic)}}
  </div>
  <mat-slider min="0" max="100" step="0.5" [value]="currentValues.metacritic" class="slider" (input)="metacriticChange($event)"></mat-slider>
</ng-container>

<button type="button" (click)="apply()" class="apply-btn blue-button">{{getString('apply')}}</button>
